import React, { useMemo } from "react";
import AvatarMale from "assets/svgs/avatars/male.svg";
import AvatarFemale from "assets/svgs/avatars/female.svg";
import AvatarSon from "assets/svgs/avatars/son.svg";
import AvatarDaughter from "assets/svgs/avatars/daughter.svg";
import AvatarFather from "assets/svgs/avatars/grandfather.svg";
import AvatarMother from "assets/svgs/avatars/grandmother.svg";

function useMemberAvatar({
  gender = "MALE",
  relationship = "SELF",
  size = 30,
  border = false,
  padding = 6,
  background = "#F7F4FF"
}) {
  const avatarIcon = useMemo(() => {
    if (gender === "MALE") {
      if (["SELF", "SPOUSE"].includes(relationship)) {
        return AvatarMale;
      }
      if (relationship === "SON") {
        return AvatarSon;
      }
      return AvatarFather;
    } else if (gender === "FEMALE") {
      if (["SELF", "SPOUSE"].includes(relationship)) {
        return AvatarFemale;
      }
      if (relationship === "DAUGHTER") {
        return AvatarDaughter;
      }
      return AvatarMother;
    }
    return AvatarMale;
  }, [gender, relationship]);

  const avatar = (
    <div
      style={{
        background,
        borderRadius: "999px",
        border: border ? "1px solid #AB9DC0" : "none",
        height: `${size}px`,
        width: `${size}px`,
        position: "relative",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
      }}
    >
      <img
        style={{
          borderRadius: "999px",
          objectFit: "cover",
          height: `${size - padding}px`,
          width: `${size - padding}px`,
        }}
        src={avatarIcon}
      />
    </div>
  );
  return { avatar };
}

export default useMemberAvatar;
